const Clipboard = {
  getString: () =>
    navigator.clipboard ? navigator.clipboard.readText() : Promise.resolve(''),
  setString: (content) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(content);
    } else {
      const el = document.createElement('textarea');
      el.value = content;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }
  },
  hasString: () => Promise.resolve(false),
  hasURL: () => Promise.resolve(false),
  hasImage: () => Promise.resolve(false),
  hasNumber: () => Promise.resolve(false),
  getImagePNG: () => Promise.reject(new Error('Not supported on web')),
  getImageJPG: () => Promise.reject(new Error('Not supported on web')),
};

export default Clipboard;
